import { render, staticRenderFns } from "./WorkOrderCard.vue?vue&type=template&id=26f10ae0&scoped=true&"
import script from "./WorkOrderCard.vue?vue&type=script&lang=js&"
export * from "./WorkOrderCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrderCard.vue?vue&type=style&index=0&id=26f10ae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f10ae0",
  null
  
)

export default component.exports